import React from "react";
import NavBar from "./NavBar";
import { Link } from "react-router-dom";
import "./ErrorPage.css"

export default function ErrorPage(){
    return (
        <>
            <div className="main-content">
                <div className="error">
                    <>404</>
                </div>
                <div className="not-found">
                    <>Page Not Found</>
                </div>
                <div className="go-back">
                    <p>The page you requested could not be found <br />Try going back to home page</p><br />
                </div>
                <Link to="/">
                    <button
                        className="home-button">
                        Go to Home
                    </button>
                </Link>
            </div>
        </>
        
    );
}

